import Vue from "vue";
import VuexRest from "./VuexRest";
import { server } from "../../config";

Vue.use(VuexRest, {
  base: server + "/rest",
});
